<script setup lang="ts">
//#region types
interface Props {
  modelValue?: boolean;
  canEdit?: boolean;
}

interface Emits {
  'update:model-value': [value: boolean];
}
//#endregion

//#region define
const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  canEdit: true,
});

const emit = defineEmits<Emits>();
//#endregion
</script>

<template>
  <div
    class="crm-activity-check-control"
    :class="{
      'crm-activity-check-control_success': modelValue,
      'crm-activity-check-control_danger': !modelValue,
    }"
  >
    <template v-if="!canEdit">
      <UiIcon
        :name="modelValue ? 'check' : 'times'"
        :size="12"
        color="inherit"
      />
    </template>

    <UiCheckbox
      v-else
      :model-value="modelValue"
      @update:model-value="emit('update:model-value', $event)"
    />
  </div>
</template>

<style lang="scss">
  .crm-activity-check-control {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border-radius: 8px 0 0 8px;

    &_success {
      border: 1px solid var(--border-positive);
      background-color: var(--background-positive-subtle);
      color: var(--text-positive);
    }

    &_danger {
      border: 1px solid var(--border-negative);
      background-color: var(--background-negative-subtle);
      color: var(--text-negative);
    }
  }
</style>
